<div class="page">
  <div class="page__container" #pageBilling>
    <h1 class="page__title spacing h2" translate>settings_edit_admin_title</h1>
    <div class="mt-5">
      <div ngbDropdown class="d-flex flex-column dropdown_small_device custom">
        <button class="btn btn-primary" id="dropdownAccountTab" #dropdown ngbDropdownToggle translate>billing_tab_billing_data</button>
        <div ngbDropdownMenu aria-labelledby="dropdownAccountTab">
          <button ngbDropdownItem translate (click)="nav.select(1); dropdown.innerText = $event.target.innerText">
            billing_tab_billing_data
          </button>
          <button ngbDropdownItem translate (click)="nav.select(2); dropdown.innerText = $event.target.innerText">
            billing_tab_invoices
          </button>
          <button ngbDropdownItem translate (click)="nav.select(3); dropdown.innerText = $event.target.innerText">
            billing_tab_subscription
          </button>
          <button ngbDropdownItem translate (click)="nav.select(4); dropdown.innerText = $event.target.innerText">
            billing_tab_credit_card
          </button>
          <button ngbDropdownItem translate (click)="nav.select(5); dropdown.innerText = $event.target.innerText">
            billing_tab_autotopup
          </button>
        </div>
      </div>
      <ul ngbNav #nav="ngbNav" (navChange)="changeTab($event)" class="nav-tabs nav_tab_large_device spacing custom" [(activeId)]="activeId">
        <li [ngbNavItem]="1">
          <a ngbNavLink translate>billing_tab_billing_data</a>
          <ng-template ngbNavContent>
            <wsb-billing-details [user]="user"></wsb-billing-details>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink translate>billing_tab_invoices</a>
          <ng-template ngbNavContent>
            <wsb-billing-orders [user]="user"></wsb-billing-orders>
          </ng-template>
        </li>
        <li [ngbNavItem]="3">
          <a ngbNavLink translate>billing_tab_subscription</a>
          <ng-template ngbNavContent>
            <wsb-billing-subscriptions></wsb-billing-subscriptions>
          </ng-template>
        </li>
        <li [ngbNavItem]="4">
          <a ngbNavLink translate>billing_tab_credit_card</a>
          <ng-template ngbNavContent>
            <wsb-billing-payment-method></wsb-billing-payment-method>
          </ng-template>
        </li>
        <li [ngbNavItem]="5">
          <a ngbNavLink translate>billing_tab_autotopup</a>
          <ng-template ngbNavContent class="mb-neg-80">
            <wsb-billing-auto-top-up [user]="user" class="mb-neg-80"></wsb-billing-auto-top-up>
          </ng-template>
        </li>
      </ul>
    </div>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
    <div [hidden]="activeId !== 1 && activeId !== 5" class="page__actions  actions-bar" #actionsBar style="z-index: 1">
      <span class="actions-bar__bg"></span>
      <div class="actions-bar__container" toastContainer></div>
      <div class="actions-bar__container  actions-bar__container--actions">
        <div class="d-flex">
          <button #submitBtn class="btn  btn-primary btn-sm" [disabled]="disableSaveButton" (click)="save()" translate>
            common_save
          </button>
          <button *ngIf="isFormDirty && !isFormPristine" (click)="resetForm()" type="button" class="btn btn-link btn-sm ms-2" translate>
            common_cancel
          </button>
        </div>
        <div *ngIf="!isFormPristine" class="mt-2">
          <span [inlineSVG]="'assets/images/icons/icon-info.svg'" class="info-icon  me-1"></span>
          <small translate>common_unsaved_changes</small>
        </div>
      </div>
    </div>
  </div>
</div>
